module.exports = __webpack_public_path__ + "img/20.095e03f7.jpg";